import React, { useEffect, useRef } from 'react'
import { observer } from 'mobx-react'
import styled from 'styled-components'
import useInject from '~/hooks/useInject'

const FlowWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  overflow: hidden;
  margin-bottom: 1.5rem;
  width: 100%;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  position: ${({ visible }) => (visible ? 'relative' : 'absolute')};
  transition: opacity 0.3s ease-in-out;

  #flow-container > * {
    border-radius: 0 !important;
    border-bottom: none !important;
  }

  #flow-container #cardAccordionContainer {
    border: none !important;
    border-bottom: 1px solid #e0e0e0 !important;
  }

  #billing-address-container input#address_line2,
  #billing-address-container input[name='shippingLine2'] {
    display: none !important;
    visibility: hidden !important;
  }

  #billing-address-container label[for='address_line2'] {
    display: none !important;
    visibility: hidden !important;
  }
`

const AddressContainer = styled.div`
  min-height: 200px;
  padding: 24px;
`

const mapStore = store => ({
  payment: store.payment,
})

const PaymentFlowContainer = ({
  initialized,
  isDashboard = false,
  showBillingAddress = true,
}) => {
  const { payment } = useInject(mapStore)
  const containerRef = useRef(null)
  const flowContainerId = isDashboard ? 'dashboard-flow-container' : 'flow-container'

  useEffect(() => {
    const root = containerRef.current
    if (!root) return

    const ensureChild = id => {
      if (document.getElementById(id)) return
      const el = document.createElement('div')
      el.id = id
      root.appendChild(el)
    }

    ensureChild(flowContainerId)
    if (showBillingAddress && !isDashboard) {
      ensureChild('billing-address-container')
    }
  }, [flowContainerId, showBillingAddress, isDashboard])

  const showCheckoutForm = initialized && payment.cko.isReady

  return (
    <FlowWrapper ref={containerRef} visible={showCheckoutForm || !initialized}>
      <div id={flowContainerId} />
      {showBillingAddress && !isDashboard && (
        <AddressContainer id="billing-address-container" />
      )}
    </FlowWrapper>
  )
}

export default observer(PaymentFlowContainer)
